const lineClamp = {
  name: "line-clamp",
  path: "/line-clamp",
  title: "line-clamp",
  description: "Utilities for clamping text to a fixed number of lines.",
  value: {
            "": {
            "line-clamp-<number>":
`overflow: hidden;
display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: <number>;`,
            },
    "line-clamp": {
      "line-clamp-none": "none"
    }
  },
  exampleData: [
    {
      example: {
        code: `
<p class="line-clamp-2 text-lg" style="max-width: 400px;">
  The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.
</p>
<p class="line-clamp-3 text-lg" style="max-width: 400px;">
  The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.
</p>
<p class="line-clamp-none text-lg" style="max-width: 400px;">
  The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.
</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">line-clamp-<var>&lt;number&gt;</var></code> to clamp text to a fixed number of lines. Use <code class="text-color-gray-800 dark:text-color-white font-semibold">line-clamp-none</code> to remove clamping.
      </p>
      <div class="space-y-6" style="max-width: 400px;">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">line-clamp-2</small>
          <p class="line-clamp-2 text-md">
            The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.
          </p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">line-clamp-3</small>
          <p class="line-clamp-3 text-md">
            The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.
          </p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">line-clamp-none</small>
          <p class="line-clamp-none text-md">
            The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.
          </p>
        </div>
      </div>
      `
    }
  ]
}
export default lineClamp;
<div className="line-clamp-2 line-clamp-3 line-clamp-none"></div>